import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getPlayerPath } from "../../utils/fanPage";

const PlayerNameLink = ({
  playerId,
  name,
  variant = "body1",
  fontWeight = 700,
  showIcon = true,
  sport = "mlb",
  linkable = true,
}) => {
  const path = linkable ? getPlayerPath(playerId, sport) : null;
  if (!path) {
    return (
      <Typography variant={variant} fontWeight={fontWeight} noWrap>
        {name}
      </Typography>
    );
  }

  return (
    <Box
      component={RouterLink}
      to={path}
      onClick={(event) => event.stopPropagation()}
      aria-label={`View ${name}’s career stats`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        minWidth: 0,
        maxWidth: "100%",
        color: "inherit",
        textDecoration: "none",
        "&:hover": {
          color: "primary.light",
          textDecoration: "underline",
        },
      }}
    >
      <Typography variant={variant} fontWeight={fontWeight} noWrap component="span">
        {name}
      </Typography>
      {showIcon && (
        <OpenInNewIcon sx={{ fontSize: 14, flexShrink: 0, opacity: 0.65 }} />
      )}
    </Box>
  );
};

export default PlayerNameLink;
